import React from 'react';
import PropTypes from 'prop-types';

import Ottercon from 'components/ottercon';
import ManagedInput from 'components/form/managed_input';

export default function AttachmentsRow({ attachment, onSelectedChanged }) {
  const handleChange = (changes) => {
    onSelectedChanged(attachment.id, changes.selected);
  };

  const { displayName, ottercon, selected } = attachment;

  return (
    <tr>
      <td className="fixed-width">
        <ManagedInput
          name="selected"
          type="checkbox"
          value={selected}
          onChange={handleChange}
        />
      </td>
      <td className="fixed-width">
        <Ottercon ottercon={ottercon} size="xs" />
      </td>
      <td className="name" name="file-name">
        {displayName}
      </td>
    </tr>
  );
}

AttachmentsRow.propTypes = {
  attachment: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    ottercon: PropTypes.string.isRequired,
    selected: PropTypes.bool,
  }),
  onSelectedChanged: PropTypes.func.isRequired
};
